<template>
  <div class="container" id="app">
    <table id="eventTable" class="table">
      <thead class="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">Name</th>
          <th scope="col">Email</th>
          <th scope="col">Mobile</th>
          <th scope="col">Address</th>
          <th scope="col">Nationality</th>
          <th scope="col">Postal Code</th>
          <th scope="col">Profession</th>
          <th scope="col">Action</th>
        </tr>
      </thead>
      <tbody>
        <!-- Write in the template Vue code here to render the table rows -->
        <template v-for="(user, users) in this.$parent.userData">
          <tr :key="users">
            <td>{{ users }}</td>
            <td>{{ user.firstname + " " + user.lastname }}</td>
            <td>{{ user.email}}</td>
            <td>{{ user.mobile}}</td>
            <td>{{ user.mainAddress + " " + user.secAddress}}</td>
            <td>{{ user.nationalitySelected}}</td>
            <td>{{ user.postalCode }}</td>
            <td>{{ user.professionSelected }}</td>
            <td>
              <button @click="fireDelete(users)">Delete</button>
            </td>
          </tr>
        </template>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  created() {
    console.log(this.$parent.userData);
  },
  methods: {
    fireDelete(users) {
      this.$parent.userData.splice(users, 1);
    },
  },
};
</script>
